'use client'

import { useTranslations } from 'next-intl'
import { reopenConsent } from './consent'
import { useConsentStatus } from './use-consent-status'

export function CookiePreferencesButton({ className }: { className?: string }) {
  const t = useTranslations('consent')
  const status = useConsentStatus()

  // Nothing to change when analytics is off, or while the banner is already showing.
  if (status === 'unavailable' || status === 'pending')
    return null

  return (
    <button type="button" onClick={reopenConsent} className={className}>
      {t('preferences')}
    </button>
  )
}
